import { commonAPIConversion } from './api-conversion-common.js';

// ************  REAL-ESTATE CONVERSION FUNCTIONS  ************

// ***************************************************************************************
// ***  convert marketing campaign from API naming convention to UI naming convention  ***
// ***************************************************************************************

const convertMarketingCampaignFromAPI = (origMarketingCampaign) => {
    if (!origMarketingCampaign) {
        return {};
    }
    const marketingCampaign = commonAPIConversion.convertEntityFromAPI(origMarketingCampaign);
    if (origMarketingCampaign.uuid) {
        marketingCampaign.uuid = origMarketingCampaign.uuid;
    }
    if (origMarketingCampaign.campaign_key) {
        marketingCampaign.campaignKey = origMarketingCampaign.campaign_key;
    }
    if (origMarketingCampaign.organization_uuid) {
        marketingCampaign.organizationUuid = origMarketingCampaign.organization_uuid;
    }
    if (origMarketingCampaign.marketing_campaign_type) {
        marketingCampaign.marketingCampaignType = commonAPIConversion.convertOptionFromAPI(origMarketingCampaign.marketing_campaign_type);
    }
    if (origMarketingCampaign.short_description) {
        marketingCampaign.shortDescription = origMarketingCampaign.short_description;
    }
    if (origMarketingCampaign.long_description) {
        marketingCampaign.longDescription = origMarketingCampaign.long_description;
    }
    if (origMarketingCampaign.landing_page_title) {
        marketingCampaign.landingPageTitle = origMarketingCampaign.landing_page_title;
    }
    if (origMarketingCampaign.landing_page_button_label) {
        marketingCampaign.landingPageButtonLabel = origMarketingCampaign.landing_page_button_label;
    }
    if (origMarketingCampaign.landing_page_image) {
        marketingCampaign.landingPageImage = origMarketingCampaign.landing_page_image;
    }
    if (origMarketingCampaign.landing_page_sub_message) {
        marketingCampaign.landingPageSubMessage = origMarketingCampaign.landing_page_sub_message;
    }
    if (origMarketingCampaign.landing_page_submitted_msg) {
        marketingCampaign.landingPageSubmittedMsg = origMarketingCampaign.landing_page_submitted_msg;
    }
    return marketingCampaign;
};

// *******************************************************
// ***  convert any list of marketing campaigns from   ***
// ***  API naming convention to UI naming convention  ***
// *******************************************************

const convertMarketingCampaignListFromAPI = (origMarketingCampaignList) => {
    if (!Array.isArray(origMarketingCampaignList)) {
        return [];
    }
    const marketingCampaignList = [];
    for (const marketingCampaign of origMarketingCampaignList) {
        marketingCampaignList.push(convertMarketingCampaignFromAPI(marketingCampaign));
    }
    return marketingCampaignList;
};

// ***************************************************************************************
// ***  convert marketing campaign from UI naming convention to API naming convention  ***
// ***************************************************************************************

const convertMarketingCampaignToAPI = (origMarketingCampaign) => {
    if (!origMarketingCampaign) {
        return {};
    }
    const marketingCampaign = commonAPIConversion.convertEntityToAPI(origMarketingCampaign);
    if (origMarketingCampaign.uuid) {
        marketingCampaign.uuid = origMarketingCampaign.uuid;
    }
    if (origMarketingCampaign.campaignKey) {
        marketingCampaign.campaign_key = origMarketingCampaign.campaignKey;
    }
    if (origMarketingCampaign.organizationUuid) {
        marketingCampaign.organization_uuid = origMarketingCampaign.organizationUuid;
    }
    if (origMarketingCampaign.marketingCampaignType) {
        marketingCampaign.marketing_campaign_type = commonAPIConversion.convertOptionToAPI(origMarketingCampaign.marketingCampaignType);
    }
    if (origMarketingCampaign.shortDescription) {
        marketingCampaign.short_description = origMarketingCampaign.shortDescription;
    }
    if (origMarketingCampaign.longDescription) {
        marketingCampaign.long_description = origMarketingCampaign.longDescription;
    }
    if (origMarketingCampaign.landingPageTitle) {
        marketingCampaign.landing_page_title = origMarketingCampaign.landingPageTitle;
    }
    if (origMarketingCampaign.landingPageButtonLabel) {
        marketingCampaign.landing_page_button_label = origMarketingCampaign.landingPageButtonLabel;
    }
    if (origMarketingCampaign.landingPageImage) {
        marketingCampaign.landing_page_image = origMarketingCampaign.landingPageImage;
    }
    if (origMarketingCampaign.landingPageSubMessage) {
        marketingCampaign.landing_page_sub_message = origMarketingCampaign.landingPageSubMessage;
    }
    if (origMarketingCampaign.landingPageSubmittedMsg) {
        marketingCampaign.landing_page_submitted_msg = origMarketingCampaign.landingPageSubmittedMsg;
    }
    return marketingCampaign;
};

// *******************************************************
// ***  convert any list of marketing campaigns from   ***
// ***  UI naming convention to API naming convention  ***
// *******************************************************

const convertMarketingCampaignListToAPI = (origMarketingCampaignList) => {
    if (!Array.isArray(origMarketingCampaignList)) {
        return [];
    }
    const marketingCampaignList = [];
    for (const marketingCampaign of origMarketingCampaignList) {
        marketingCampaignList.push(convertMarketingCampaignToAPI(marketingCampaign));
    }
    return marketingCampaignList;
};

// **********************************************************************
// ***  convert contact requesting resource to API naming convention  ***
// **********************************************************************

const convertContactToAPI = (origContact) => {
    console.log('converting original contact:');
    console.log(origContact);
    const contact = {};
    if (!origContact) {
        return contact;
    }
    if (origContact.marketingCampaignId) {
        contact.marketing_campaign_id = origContact.marketingCampaignId;
    }
    if (origContact.firstName) {
        contact.first_name = origContact.firstName;
    }
    if (origContact.lastName) {
        contact.last_name = origContact.lastName;
    }
    if (origContact.emailAddress) {
        contact.email = origContact.emailAddress;
    }
    if (origContact.phoneNumber) {
        contact.phone = origContact.phoneNumber;
    }
    console.log('to updated contact:');
    console.log(contact);
    return contact;
};

// ****************************************************************
// ***  expose API Utility Method Calls to API Services
// ****************************************************************

export const realEstateAPIConversion = {
    convertMarketingCampaignFromAPI,
    convertMarketingCampaignListFromAPI,
    convertMarketingCampaignToAPI,
    convertMarketingCampaignListToAPI,
    convertContactToAPI
};